import Model from './Model';
import { Component, ComponentVariation, CustomizationNode } from '@/models';
import CustomizationTemplate from './CustomizationTemplate';

export default class ComponentConfiguration extends Model {
  static type = 'componentConfigurations';

  component: Component;
  variation: ComponentVariation;
  template: CustomizationTemplate;
  customizationNodes: CustomizationNode[] = [];
  total: number;
  canvas?: HTMLCanvasElement;

  static init(component: Component, variation: ComponentVariation, template?: CustomizationTemplate){
    const componentConfiguration = new ComponentConfiguration({});
    componentConfiguration.component = component;
    componentConfiguration.variation = variation;
    componentConfiguration.template = template;
    componentConfiguration.customizationNodes = [];
    return componentConfiguration;
  }
}
